import styled from "styled-components";
import { H1, H2, P, MainWrapper } from "@/lib/styles";

export const Container = styled(MainWrapper)`
  padding-bottom: 0;
`;

export const Heading = styled(H2)`
  padding: 5rem 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 9.625rem 0;
  }
`;
